/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_6_P2Inputs */

const en_terms_section_6_p2 = /** @type {(inputs: Terms_Section_6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How personal data is handled on this website is set out in our`)
};

const lv_terms_section_6_p2 = /** @type {(inputs: Terms_Section_6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā šajā tīmekļvietnē tiek apstrādāti personas dati, ir aprakstīts mūsu`)
};

/**
* | output |
* | --- |
* | "How personal data is handled on this website is set out in our" |
*
* @param {Terms_Section_6_P2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_6_p2 = /** @type {((inputs?: Terms_Section_6_P2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_6_P2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_6_p2(inputs)
	return en_terms_section_6_p2(inputs)
});